import { defineComponent, ref, computed, openBlock, createElementBlock, normalizeClass, normalizeStyle, Fragment, renderList } from 'vue';
import { q as hs } from '../OrAutocompleteV3-508d99c0.js';
import range from 'lodash/range';
import '@vueuse/core';
import '@onereach/styles/screens.json';
import '@onereach/styles/tailwind.config.json';
import 'lodash/get';
import 'lodash/isElement';
import '../or-error-v3/index.js';
import '../or-hint-v3/index.js';
import '../or-icon-button-v3/index.js';
import '../or-icon-v3/index.js';
import '../or-tooltip-v3/index.js';
import '../or-popover-v3/index.js';
import '@floating-ui/dom';
import '../or-bottom-sheet-v3/index.js';
import '../or-overlay-v3/index.js';
import '../or-teleport-v3/index.js';
import '../or-input-box-v3/index.js';
import '../or-input-v3/index.js';
import '../OrInlineInputV3-46210775.js';
import '../or-inline-input-box-v3/index.js';
import '../or-text-v3/index.js';
import '../or-label-v3/index.js';
import '../or-loader-v3/index.js';
import '../or-menu-item-v3/index.js';
import '../or-tag-input-v3/index.js';
import '../or-tags-v3/index.js';
import '../or-button-v3/index.js';
import '../or-tag-v3/index.js';

const SkeletonRoot = [
// Position
'relative',
// Layout
'overflow-hidden',
// Box
'p-0',
// Borders
'border-0',
// Theme
'bg-skeletons-gradient', 'dark:bg-skeletons-gradient-dark',
// Background
'bg-repeat'];
const SkeletonTextContainerRoot = [
// Layout
'flex', 'flex-col',
// Box
'h-auto'];
const SkeletonCircle = [
// Box
'rounded-full'];
const SkeletonRect = [
// Box
'rounded-md'];
const SkeletonText = [
// Box
'w-full', 'rounded-md'];
const SkeletonAnimated = [
// Background
'bg-[length:200%]',
// Animation
'animate-skeleton-loader'];

var script$2 = defineComponent({
  name: 'OrSkeletonCircle',
  props: {
    animated: {
      type: Boolean,
      required: false,
      default: true
    },
    size: {
      type: [Number, String],
      required: false,
      default: 40
    }
  },
  expose: ['root'],
  setup(props) {
    // Refs
    const root = ref();
    // Styles
    const rootStyles = computed(() => ['or-skeleton-v3', 'or-skeleton-circle', ...SkeletonRoot, ...SkeletonCircle, ...(props.animated ? SkeletonAnimated : [])]);
    const rootStyle = computed(() => {
      var _a;
      const size = (_a = props.size) !== null && _a !== void 0 ? _a : 40; // 40px - medium OrAvatar
      const sizeStyle = typeof size === 'number' ? hs(size) : size;
      return {
        'width': sizeStyle,
        'min-width': sizeStyle,
        'height': sizeStyle,
        'min-height': sizeStyle
      };
    });
    return {
      root,
      rootStyles,
      rootStyle
    };
  }
});

function render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles),
    style: normalizeStyle(_ctx.rootStyle)
  }, null, 6 /* CLASS, STYLE */);
}

script$2.render = render$2;
script$2.__file = "src/components/or-skeleton-v3/or-skeleton-circle-v3/OrSkeletonCircle.vue";

var script$1 = defineComponent({
  name: 'OrSkeletonRect',
  props: {
    animated: {
      type: Boolean,
      required: false,
      default: true
    },
    width: {
      type: [Number, String],
      required: false,
      default: '100%'
    },
    height: {
      type: [Number, String],
      required: false,
      default: 36
    }
  },
  expose: ['root'],
  setup(props) {
    // Refs
    const root = ref();
    // Styles
    const rootStyles = computed(() => ['or-skeleton-v3', 'or-skeleton-rect', ...SkeletonRoot, ...SkeletonRect, ...(props.animated ? SkeletonAnimated : [])]);
    const rootStyle = computed(() => {
      var _a, _b;
      const width = (_a = props.width) !== null && _a !== void 0 ? _a : '100%';
      const height = (_b = props.height) !== null && _b !== void 0 ? _b : 36; // 36px - default OrInput height
      return {
        'width': typeof width === 'number' ? hs(width) : width,
        'height': typeof height === 'number' ? hs(height) : height
      };
    });
    return {
      root,
      rootStyles,
      rootStyle
    };
  }
});

function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles),
    style: normalizeStyle(_ctx.rootStyle)
  }, null, 6 /* CLASS, STYLE */);
}

script$1.render = render$1;
script$1.__file = "src/components/or-skeleton-v3/or-skeleton-rect-v3/OrSkeletonRect.vue";

var script = defineComponent({
  name: 'OrSkeletonText',
  props: {
    animated: {
      type: Boolean,
      required: false,
      default: true
    },
    linesCount: {
      type: Number,
      required: false,
      default: 1
    },
    width: {
      type: [Number, String],
      required: false,
      default: '100%'
    },
    fontSize: {
      type: Number,
      required: false,
      default: 16
    },
    lineHeight: {
      type: Number,
      required: false,
      default: 24
    }
  },
  expose: ['root'],
  setup(props) {
    // Refs
    const root = ref();
    // Styles
    const containerStyles = computed(() => ['or-skeleton-text-root', ...SkeletonTextContainerRoot]);
    const containerStyle = computed(() => {
      var _a;
      const width = (_a = props.width) !== null && _a !== void 0 ? _a : '100%';
      return {
        'width': typeof width === 'number' ? hs(width) : width
      };
    });
    const rowStyles = computed(() => ['or-skeleton-v3', 'or-skeleton-text', ...SkeletonRoot, ...SkeletonText, ...(props.animated ? SkeletonAnimated : [])]);
    const rowStyle = computed(() => {
      var _a, _b;
      const height = (_a = props.fontSize) !== null && _a !== void 0 ? _a : 16;
      const margin = (((_b = props.lineHeight) !== null && _b !== void 0 ? _b : 24) - height) / 2;
      return {
        'height': typeof height === 'number' ? hs(height) : height,
        'margin': `${typeof margin === 'number' ? hs(margin) : margin} 0`
      };
    });
    // State
    const lineKeys = computed(() => range(props.linesCount));
    return {
      root,
      containerStyles,
      containerStyle,
      rowStyles,
      rowStyle,
      lineKeys
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.containerStyles),
    style: normalizeStyle(_ctx.containerStyle)
  }, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.lineKeys, key => {
    return openBlock(), createElementBlock("div", {
      key: key,
      class: normalizeClass(_ctx.rowStyles),
      style: normalizeStyle(_ctx.rowStyle)
    }, null, 6 /* CLASS, STYLE */);
  }), 128 /* KEYED_FRAGMENT */))], 6 /* CLASS, STYLE */);
}

script.render = render;
script.__file = "src/components/or-skeleton-v3/or-skeleton-text-v3/OrSkeletonText.vue";

export { script$2 as OrSkeletonCircleV3, script$1 as OrSkeletonRectV3, script as OrSkeletonTextV3 };
